import { Sun, HandHeart, Sparkles } from "lucide-react";

const pillars = [
  {
    icon: HandHeart,
    title: "Held with intention",
    body: "We tend to your physical recovery, emotional wellbeing, and the rhythm of your home so you can pour into your baby.",
  },
  {
    icon: Sun,
    title: "Daytime nourishment",
    body: "From warm meals and light tidying to feeding support and a calm presence — quiet, capable help through your day.",
  },
  {
    icon: Sparkles,
    title: "Confidence to grow into",
    body: "Gentle, evidence-informed guidance on feeding, soothing and newborn rhythms — at your pace, in your home.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32"
      style={{ background: "var(--bg-secondary)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <span className="section-eyebrow">What we do</span>
            <span className="gold-divider ml-3 mb-2 align-middle" />
            <h2
              className="font-serif-display mt-4 text-4xl md:text-5xl lg:text-6xl leading-[1.05]"
              style={{ color: "var(--text-main)" }}
              data-testid="about-headline"
            >
              The fourth trimester deserves <em className="not-italic" style={{ color: "var(--blush)" }}>tender, knowledgeable</em> care.
            </h2>
          </div>
          <div className="lg:col-span-7">
            <p
              className="text-base md:text-lg leading-relaxed"
              style={{ color: "var(--text-main)" }}
              data-testid="about-paragraph"
            >
              Postpartum is a sacred season — and an immense one. At Nourished Nest, we walk beside families
              across <b>Greater Brisbane</b> through the early weeks with non-judgmental, evidence-informed
              support. We are an extra pair of capable hands, a calming presence, and a guide as you find
              your footing as a parent.
            </p>
            <p className="mt-5 leading-relaxed" style={{ color: "var(--text-muted)" }}>
              Whether you are weeks from your due date or already cradling your newborn, our care is shaped
              around <em>your</em> family — your home, your culture, your goals.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
              {pillars.map((p, i) => (
                <div
                  key={p.title}
                  className="brand-card p-6"
                  data-testid={`about-pillar-${i}`}
                >
                  <div
                    className="w-11 h-11 rounded-full flex items-center justify-center mb-4"
                    style={{ background: "var(--gold-light)" }}
                  >
                    <p.icon size={20} color="var(--gold)" />
                  </div>
                  <h3 className="font-serif-display text-2xl mb-2" style={{ color: "var(--text-main)" }}>
                    {p.title}
                  </h3>
                  <p className="text-sm leading-relaxed" style={{ color: "var(--text-muted)" }}>
                    {p.body}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
